import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { CustomerTaxResidencyModel } from '../../Models/Models/Customer/Regulatory/CustomerTaxResidencyModel';
import { ValidationStatus } from '../../Core/Web/Validation/ValidationStatus';

declare var IS_RUNNING_IN_APP_POOL;

export class CustomerTaxResidencyClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(customerId: number): Promise<Array<CustomerTaxResidencyModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/CustomerTaxResidency/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId }

    return AjaxWrapper.get<Array<CustomerTaxResidencyModel>, any>(url, data);
  }
  public put(customerId: number, models: Array<CustomerTaxResidencyModel>): Promise<Array<ValidationStatus>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/CustomerTaxResidency/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId, models: models }

    return AjaxWrapper.put<Array<ValidationStatus>, any>(url, data);
  }
}

